import { useQuery } from "@tanstack/react-query";
import documentsClient from "../../api/private/documentsClient";
import {
  CPCustomFormReportDocumentDetail,
  CPCustomFormReportDocumentListResponse,
} from "../../api/models/unified";

const documentKey = "documentKey";

export const getDocumentDetailQueryKeyBuilder = (id: string) => [
  documentKey,
  id,
];

export const getDocumentsByDayQueryKeyBuilder = (days: number) => [
  documentKey,
  days,
];

export const useGetDocumentDetailQuery = (id?: string) => {
  return useQuery<CPCustomFormReportDocumentDetail>({
    queryKey: getDocumentDetailQueryKeyBuilder(id ?? ""),
    queryFn: () => documentsClient.getDocumentDetail(id ?? ""),
    enabled: !!id,
  });
};

export const useGetDocumentsByDaysQuery = (days: number) => {
  return useQuery<CPCustomFormReportDocumentListResponse>({
    queryKey: getDocumentsByDayQueryKeyBuilder(days),
    queryFn: () => documentsClient.getDocumentsByDays(days),
  });
};
